interface Model<T = number> {
  id: T;
  createdDate: Date;
  updatedDate: Date;
}

export interface VaccinationSchedule extends Model {
  startDate: Date;
  endDate: Date;
  interval: number;
  VaccinationCampaignId: number;
}

export interface VaccinationCampaign extends Model {
  description: string;
  startDate: Date;
  endDate: Date;
  vaccinationSchedule: VaccinationSchedule[];
}

export interface VaccinationPoint extends Model {
  description: string;
  address: string;
  neighborhood: string;
  city: string;
  state: string;
  baseIdentifier: string;
}

export enum LocationType {
  WorkPlace = 'workPlace',
  AccreditedNetwork = 'accreditedNetwork',
  Refund = 'refund',
}

export enum TransportType {
  PublicTransportation = 'publicTransportation',
  OwnVehicle = 'ownVehicle',
  AppOrTaxi = 'appOrTaxi',
}

export enum VaccinationStatusType {
  Rejected = 'rejected',
  Accepted = 'accepted',
  Canceled = 'canceled',
  Attended = 'attended',
  Scheduled = 'scheduled',
}

export interface VaccinationSchema {
  id?: number;
  scheduledDate?: string;
  vehicleId?: string;
  transportType?: TransportType;
  status?: VaccinationStatusType;
}
export interface WorkPlace extends Model {
  city: string;
  description: string;
}

export interface UserVaccination extends Model {
  status: VaccinationStatusType;
  scheduledDate: Date;
  locationType: LocationType;
  transportType: TransportType;
  vehicleId?: number;
  VaccinationCampaignId: number;
  VaccinationPointId?: number;
  UserId: number;
  WorkplaceId?: number;
  workplace?: WorkPlace;
  vaccinationPoint?: VaccinationPoint;
  locationComplement?: string;
  locationDescription?: string;
}

export interface PostUserVaccination {
  vehicleId?: string;
  transportType?: TransportType;
  scheduledDate?: Date;
}
